module.exports = __webpack_public_path__ + "img/Speaker=Matt Espinoza.253f18ed.png";